/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_WorkingInputs */



/**
* | output |
* | --- |
* | "Work in progress. Please wait..." |
*
* @param {Options_Api_Keys_WorkingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_working = /** @type {((inputs?: Options_Api_Keys_WorkingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_WorkingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Traitement en cours. Veuillez patienter...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Arbeiten laufen. Bitte warten Sie...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lavori in corso. Attendi...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Работа продолжается. Пожалуйста, подождите...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Trabajo en progreso. Por favor, espere...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("正在处理中，请稍候……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業中です。しばらくお待ちください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("काम जारी है। कृपया प्रतीक्षा करें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Trabalho em andamento. Aguarde...")
	return /** @type {LocalizedString} */ ("Work in progress. Please wait...")
});